import { Animation, PageTransition } from 'ionic-angular';

/**
 * Animations for modals
 */
export class ModalSlideRightEnterTransition extends PageTransition {
    init() {
        super.init();
        const ele: HTMLElement = this.enteringView.pageRef().nativeElement;
        const backdropEle = ele.querySelector('ion-backdrop');
        const backdrop = new Animation(this.plt, backdropEle);
        const wrapper = new Animation(this.plt, ele.querySelector('.modal-wrapper'));

        wrapper.beforeStyles({ 'opacity': 1 });
        wrapper.fromTo('translateX', '100%', '0%');

        backdrop.fromTo('opacity', 0.01, 0.4);

        this
            .element(this.enteringView.pageRef())
            .easing('cubic-bezier(0.36,0.66,0.04,1)')
            .duration(400)
            .add(backdrop)
            .add(wrapper);
    }
}


// WEBPACK FOOTER //
// ./src/transitions/slide/slide-right-enter.transition.ts